import ptBrTranslations from './pt-br'
import enUsTranslations from './en-us'
import esTranslations from './es'

export default {
  'pt': ptBrTranslations,
  'pt-BR': ptBrTranslations,
  'en-US': enUsTranslations,
  'en': enUsTranslations,
  'es': esTranslations
}